import React from 'react'

const PendingSentReqItem = () => {
  return (
    <div>PendingSentReqItem</div>
  )
}

export default PendingSentReqItem